const swiperReviewsss = new Swiper('.review-slider__contents', {
  loop: true,
  slidesPerView: 1.11,
  spaceBetween: 12,
  pagination: {
    el: '.review-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: `.swiper-button-next-review`,
    prevEl: `.swiper-button-prev-review`,
    enabled: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 3,
      spaceBetween: 26,
    }
  }
});
